module.exports = __webpack_public_path__ + "img/login-points.1417dc23.svg";